/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import Compressor from "compressorjs";
import toStream from "it-to-stream";
// import FileType from 'file-type';
import { fileTypeFromBuffer } from "file-type";

import { IPFSHTTPClient } from "ipfs-http-client";

import ipfs from "../config/ipfs";

interface CompressorOptions {
  quality: number;
  success: (result: File) => void;
}

export async function compressImage(image: File): Promise<File> {
  return new Promise((resolve, reject) => {
    try {
      new Compressor(image, {
        quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
        success: (compressedResult: File) => {
          resolve(compressedResult);
          // compressedResult has the compressed file.
          // Use the compressed file to upload the images to your server.
        },
      } as CompressorOptions);
    } catch {
      reject(undefined);
    }
  });
}

export async function getFileType(url: string | undefined): Promise<string> {
  if (!url) return "";
  let ipfsHash = url.substring(url.lastIndexOf("/") + 1); // substract ipfs hash
  const ext = await getFile(ipfsHash);
  return ext.substring(0, ext.lastIndexOf("/"));
}

export async function getFile(cid: string): Promise<string> {
  // const type = await FileType.fromStream(toStream(ipfs.cat(cid, {
  //   length: 100 // or however many bytes you need
  // })))
  const type = await FileType.fromStream(toStream(ipfs.cat(cid, {})));
  return type?.mime || "";
}

export function convertUnixToISO(timestamp: number): string {
  return new Date(timestamp * 1000).toISOString();
}
